import { detectZoom } from './detectZoom';

// 检测是否为移动设备
const isMobileDevice = () => {
  return /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
};

// 处理缩放逻辑
const handleZoom = () => {
  // 移动设备不处理缩放
  if (isMobileDevice()) {
    return;
  }

  // 其他设备（桌面端）禁止缩放
  const m = detectZoom();
  // 强制设置缩放为100%
  document.body.style.zoom = 1;

  // 添加 no-zoom 类来控制缩放
  document.body.classList.add('no-zoom');
};

// 执行缩放处理
handleZoom();

// 监听窗口大小变化，重新处理缩放（仅对非移动设备）
window.addEventListener('resize', () => {
  if (!isMobileDevice()) {
    handleZoom();
  }
});

// 阻止键盘缩放快捷键
document.addEventListener('keydown', (e) => {
  // 阻止 Ctrl + +/- 或 Cmd + +/- 缩放
  if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-' || e.key === '=')) {
    e.preventDefault();
  }
});

// 阻止滚轮缩放
document.addEventListener('wheel', (e) => {
  if (e.ctrlKey) {
    e.preventDefault();
  }
}, { passive: false });

// 阻止触摸缩放
document.addEventListener('touchstart', (e) => {
  if (e.touches.length > 1) {
    e.preventDefault();
  }
}, { passive: false });

const app = {
  state: {
    router: [],
    honorShowView: false
  },
  mutations: {
    setHonorShowView(state, honorShowView) {
      state.honorShowView = honorShowView;
    }
  },
  // 添加缩放控制方法
  methods: {
    updateZoom() {
      handleZoom();
    },
    setZoom(scale) {
      // 只对非移动设备生效
      if (!isMobileDevice()) {
        document.body.style.zoom = 1;
        document.body.classList.add('no-zoom');
      }
    }
  }
};

// 确保在应用初始化时调用一次 setZoom 方法
if (app.methods && typeof app.methods.setZoom === 'function') {
  // 延迟执行确保DOM完全加载
  setTimeout(() => {
    app.methods.setZoom();
  }, 0);
}

export default app;
